import React from "react";
import { URLdecode, URLencode } from "../../utils/url";
import { configurations } from "../../configurations";
import { useLocation, useNavigate } from "react-router-dom";
import InvoiceTable from "./InvoiceTable";
import InvoiceServicesTable from "./InvoiceServicesTable";
import InvoiceCustomersTable from "./InvoiceCustomersTable";

function InvoiceContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = URLdecode();
  return (
    <div className="w-full flex flex-col">
      <div className="w-full bg-gray-100 rounded-md p-2 flex">
        {[
          {
            label: configurations.invoice.tabs.invoice.label,
            value: configurations.invoice.tabs.invoice.value,
          },
          {
            label: configurations.invoice.tabs.service.label,
            value: configurations.invoice.tabs.service.value,
          },
          {
            label: configurations.invoice.tabs.customer.label,
            value: configurations.invoice.tabs.customer.value,
          },
        ].map((item, itemIndex) => {
          let selected =
            (!params?.tab &&
              item.value === configurations.invoice.tabs.invoice.value) ||
            params?.tab === item.value;
          const handleClick = () => {
            navigate(
              `${location.pathname}?${URLencode({
                ...params,
                tab: item.value,
              })}`
            );
          };
          return (
            <button
              key={itemIndex}
              onClick={handleClick}
              className={`flex flex-1 h-12 items-center justify-center rounded-md ${
                selected
                  ? "bg-[#15447D] text-white font-medium"
                  : "text-black bg-transparent"
              }`}
            >
              {item.label}
            </button>
          );
        })}
      </div>
      <div className="flex flex-col w-full pt-3">
        {(() => {
          switch (params?.tab) {
            case configurations.invoice.tabs.service.value:
              return <InvoiceServicesTable />;
            case configurations.invoice.tabs.customer.value:
              return <InvoiceCustomersTable />;
            case configurations.invoice.tabs.invoice.value:
            default:
              return <InvoiceTable />;
          }
        })()}
      </div>
    </div>
  );
}

export default InvoiceContent;
